import React from 'react';
import partnerBanner from '../img/envision/qualityimges/qualitybanner.JPG';

const AboutqualityBanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center' }}>QUALITY AND CERTIFICATIONS</h1>
            </div>

            {/* Image */}
            <img
                src={partnerBanner}
                alt="partner banner"
                style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
            />
        </div>
    );
};

export default AboutqualityBanner;
